export default {
    clientWidth: null,
    footerHeight: null,
    initialized: false,
    retina: false,
    theme: {}
};



// WEBPACK FOOTER //
// ./src/redux/reducers/ui/init.js